import { rotateBoard } from "../helpers-board.js";

function rotateBoardRandom({ board, registerCleanup }) {
  // rotateBoard(Math.random() * 270, { board });
  board.style.setProperty('--random-angle', `${Math.random() * 270}deg`);
  board.classList.add('rotated');

  function cleanup() {
    board.style.setProperty('--random-angle', '0deg');
    board.classList.remove('rotated');
  };

  registerCleanup(cleanup);
}

function rotateBoardNormal({ board }) {
  rotateBoard(0, { board });
}
function rotateBoard90() {
  rotateBoard(90);
}

function rotateBoard180() {
  rotateBoard(180);
}

function rotateBoard270() {
  rotateBoard(270);
}


export { rotateBoardRandom, rotateBoardNormal }
